import router from '@/router';
import store from '@/store';
import {get} from 'lodash-es'

router.beforeEach(async () => {
  if(get(store.state.app.userInfo, 'user.id', -1) === -1){
    await store.dispatch('getUserInfo');
  }
  return true;
});